import PropTypes from 'prop-types';
import {
  LESSON_STATUSES,
  LESSON_TYPES,
} from '../../../services/utilityFunctions';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import VideoProp from '../../../commonComponents/propTypes/videoProp';
import YoutubeProp from '../../../commonComponents/propTypes/youtubeProp';
import QuestionProp from './questionProp';

const propType = {
  _id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(LESSON_TYPES).isRequired,
  preview: PropTypes.shape(ImageProp.propType),
  video: PropTypes.shape(VideoProp.propType),
  pdf: PropTypes.shape({}),
  youtube: PropTypes.shape(YoutubeProp.propType),
  images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
  pos: PropTypes.number.isRequired,
  level: PropTypes.number.isRequired,
  duration: PropTypes.number,
  questions: PropTypes.number,
  questionsList: PropTypes.arrayOf(PropTypes.shape(QuestionProp.propType)),
  status: PropTypes.oneOf(LESSON_STATUSES),
  congrats: PropTypes.bool.isRequired,
};

export default { propType };
